export default __webpack_public_path__ + "static/media/devices-guide-mob-new.4857d86f.png";